/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Colors, Link, Text } from '@zapier/design-system';
import { Fragment } from 'react';
import { ZAPIER_APP_BASE_URL } from 'app/common/constants';

const sizeLarge = '1300px';

const styleBanner = css`
  margin-top: 40px;
  display: grid;
  grid-template-columns: 1fr;
  border-radius: 10px;
  background: ${Colors.BrandEarth};
  color: ${Colors.PrimeWhite};

  @media (min-width: ${sizeLarge}) {
    grid-template-columns: 1fr 1.2fr;
  }
`;

const styleBannerText = css`
  padding: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const styleImageBackground = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;

  @media (min-width: ${sizeLarge}) {
    justify-content: flex-end;
  }

  img {
    width: 100%;
    height: auto;
    max-width: 600px;
    object-fit: contain;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgb(0 0 0 / 50%);
  }
`;

export function AutomationBannerSection() {
  return (
    <Fragment>
      <section css={styleBanner}>
        <div css={styleBannerText}>
          <Text color="inherit" tag="div" type="Body1">
            Most partners who embed Zapier see a{' '}
            <Text color="inherit" margin="10px 0" tag="div" type="PageHeader">
              29&ndash;65% user increase
            </Text>{' '}
            in integration usage, along with higher retention, more customer
            upgrades, and improved lifetime value from their users within 6
            months.
          </Text>
        </div>
        <div css={styleImageBackground}>
          <img
            alt="Zap Templates Element"
            height={1394}
            src="/images/zap-templates-element.png"
            width={1188}
          />
        </div>
      </section>
      <Text fontWeight={700} margin="25px 0px" tag="p" type="Body1">
        Embedding Zapier allows your users to automate workflows without leaving
        your product
      </Text>
      <Text margin="0px 0px" tag="p" type="Body1">
        You can embed the out-of-the box{' '}
        <Link
          href={`${ZAPIER_APP_BASE_URL}/partner/embed/workflow`}
          target="_blank"
        >
          Workflow Element
        </Link>
        , or build a custom product experience with the{' '}
        <Link href="https://docs.api.zapier.com" target="_blank">
          Workflow API
        </Link>
      </Text>
    </Fragment>
  );
}
